import { Text } from "@ui-component-library";
import { SubscriptionInfo, OrderSummary } from "../sections";
import { SelectProperty } from "../components/SelectProperty";

export default function Order() {
  return (
    <div className="flex flex-col w-full gap-8">
      <div>
        <div className="w-full flex flex-col gap-1-5">
          <div className="flex flex-col gap-2 mx-4 mb-4">
            <Text variant="text-base/leading-normal/medium">Välj fastighet</Text>
            <Text
              variant="text-sm/leading-normal/normal"
              className="text-[#737373]"
            >
              Lägg till en eller flera fastigheter
            </Text>
          </div>

          <div className="flex flex-col rounded-2xl bg-white-50 p-4 w-full gap-4">
            <SelectProperty />
          </div>
        </div>
      </div>
      <div className="w-full h-[0.5px] border border-stone-500/17" />
      <SubscriptionInfo />
      <div className="w-full h-[0.5px] border border-stone-500/17" />
      <OrderSummary />
    </div>
  );
}
